// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbsContainer":"_331PX","breadcrumb-link":"_3XQ7V","breadcrumbLink":"_3XQ7V"};